import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import AnimateHeight from "react-animate-height";
import style from "./FundraiserGiftActivity.module.scss";
import { thousandize } from "../../../../util/formatting";
import { FetchFundraiserResult } from "../../../../studio/sanity.types";
export const FundraiserGiftActivity: React.FC<{
  config: NonNullable<FetchFundraiserResult["page"]>["gift_activity_config"];
  donations: {
    amount: number;
    name: string | null;
    message: string | null;
  }[];
  locale: string;
}> = t0 => {
  const $ = _c(37);
  const {
    donations,
    config,
    locale
  } = t0;
  const [currentlyShowing, setCurrentlyShowing] = useState(5);
  if (!config) {
    return "Missing config for fundraiser gift activity";
  }
  if (!config.title) {
    return "Missing title";
  }
  if (!config.gift_amount_text_template) {
    return "Missing gift amount text template";
  }
  if (!config.anonymous_gift_amount_text_template) {
    return "Missing anonymous gift amount text template";
  }
  if (!config.show_more_text_template) {
    return "Missing show more text template";
  }
  if (!config.no_donations_text) {
    return "Missing no donations text";
  }
  const {
    gift_amount_text_template,
    anonymous_gift_amount_text_template,
    show_more_text_template,
    no_donations_text,
    title
  } = config;
  let t1;
  if ($[0] !== currentlyShowing || $[1] !== donations.length || $[2] !== show_more_text_template) {
    t1 = show_more_text_template.replace("{count}", (donations.length - currentlyShowing).toString());
    $[0] = currentlyShowing;
    $[1] = donations.length;
    $[2] = show_more_text_template;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const showMoreText = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[4] !== anonymous_gift_amount_text_template || $[5] !== currentlyShowing || $[6] !== donations || $[7] !== gift_amount_text_template || $[8] !== locale || $[9] !== title) {
    const divviedDonations = donations.reduce(_temp, [] as {
      amount: number;
      name: string | null;
      message: string | null;
    }[][]);
    let t6;
    if ($[14] !== anonymous_gift_amount_text_template || $[15] !== gift_amount_text_template || $[16] !== locale) {
      t6 = (name, amount) => {
        const template = name ? gift_amount_text_template : anonymous_gift_amount_text_template;
        return template.replace("{name}", name ?? "Donor").replace("{sum}", thousandize(amount, locale));
      };
      $[14] = anonymous_gift_amount_text_template;
      $[15] = gift_amount_text_template;
      $[16] = locale;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    const getHeaderText = t6;
    t2 = style.container;
    t3 = "fundraiser-gift-activity";
    if ($[18] !== title) {
      t4 = <span className={style.title} data-cy="fundraiser-gift-title">{title}</span>;
      $[18] = title;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    let t7;
    if ($[20] !== currentlyShowing || $[21] !== getHeaderText) {
      t7 = (donationGroup, i_0) => <AnimateHeight key={i_0} duration={300} height={i_0 < currentlyShowing / 5 ? "auto" : 0}>{donationGroup.map((donation_0, j) => <div key={j} className={style.donation} data-cy="fundraiser-gift-item"><span className={style.amount} data-cy="fundraiser-gift-amount">{getHeaderText(donation_0.name, donation_0.amount)}</span>{donation_0.message && <span className={style.message} data-cy="fundraiser-gift-message">{donation_0.message}</span>}</div>)}</AnimateHeight>;
      $[20] = currentlyShowing;
      $[21] = getHeaderText;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t5 = divviedDonations.map(t7);
    $[4] = anonymous_gift_amount_text_template;
    $[5] = currentlyShowing;
    $[6] = donations;
    $[7] = gift_amount_text_template;
    $[8] = locale;
    $[9] = title;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[23] !== donations.length || $[24] !== no_donations_text) {
    t6 = donations.length === 0 && <div className={style.noDonations}><span>{no_donations_text}</span></div>;
    $[23] = donations.length;
    $[24] = no_donations_text;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== currentlyShowing || $[27] !== donations.length || $[28] !== showMoreText) {
    t7 = currentlyShowing < donations.length && <button onClick={() => setCurrentlyShowing(currentlyShowing + 5)} className={style.seemore} data-cy="fundraiser-gift-show-more">{showMoreText}</button>;
    $[26] = currentlyShowing;
    $[27] = donations.length;
    $[28] = showMoreText;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7) {
    t8 = <div className={t2} data-cy={t3}>{t4}{t5}{t6}{t7}</div>;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
};
function _temp(acc, donation, i) {
  const index = Math.floor(i / 5);
  acc[index] = acc[index] || [];
  acc[index].push(donation);
  return acc;
}